// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.q-page-header[data-v-41451158] {\n  width: 100%;\n}\n.q-page-header > h3[data-v-41451158] {\n  font-size: 24px;\n  line-height: 1.1;\n  color: #929292;\n  font-weight: 400;\n  background-color: #fafbfc;\n  border-bottom: 1px solid #cfdbe2;\n  padding: 15px;\n}\n.q-page-header > h3 > small[data-v-41451158] {\n  display: block;\n  font-size: 12px;\n  color: #909fa7;\n  font-weight: 400;\n  line-height: 1;\n}\n", ""]);
// Exports
module.exports = exports;
